import React from 'react'
// components
import PlanTypesContainer from 'containers/PlanTypes'

const PlanTypesSettingsPage: React.FC = () => <PlanTypesContainer />

export default PlanTypesSettingsPage
